// src/components/LayoutHandler.jsx
import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import AnimatedOutlet from "./Common/AnimatedOutlet/AnimatedOutlet";
import ProfessionalHeader from "./Professional/Header/Header";
import ProfessionalFooter from "./Professional/Footer/Footer";
import ClientHeader from "./Client/Header/Header";
import ClientFooter from "./Client/Footer/Footer";
import CommonHeader from "./Common/Header/Header";
import CommonFooter from "./Common/Footer/Footer";

import { Col, Row } from "react-bootstrap";
import apple from "../../src/assets/img/apple_head.png";
import robot from "../../src/assets/img/Vector.png";

import { ToastContainer } from "react-toastify";
import Loader from "./Loader/Loader";
import { useGlobalState } from "../Providers/GlobalStateProvider";

const PROFESSIONAL_PUBLIC_ROUTES = [
  "/professional/login",
  "/professional/signup",
  "/professional/signup-one",
  "/professional/signup-two",
  "/professional/signup-three",
  "/professional/signup-four",
  "/professional/forgot-password",
];

const parseStoredJson = (key) => {
  try {
    const raw = localStorage.getItem(key);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

const LayoutHandler = () => {
  const [authType, setAuthType] = useState("none"); // 'professional' | 'client' | 'none'
  const [showFooter, setShowFooter] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();
  const { globalLoading } = useGlobalState();

  // Watch authentication state
  useEffect(() => {
    const checkAuth = () => {
      const pathname = location.pathname;
      const professionalData = parseStoredJson("professionalData");
      const clientData = parseStoredJson("clientData");
      const hasProfessionalToken = Boolean(localStorage.getItem("professionalToken"));
      const hasClientToken = Boolean(localStorage.getItem("clientToken"));
      const professionalSteps = Number(professionalData?.profileSteps);
      const clientSteps = Number(clientData?.profileSteps);

      const isProfessionalAppRoute =
        pathname.startsWith("/professional") &&
        !PROFESSIONAL_PUBLIC_ROUTES.some((route) => pathname.startsWith(route));

      // Logged-in pro on dashboard/app routes, or completed onboarding (steps 1 or 4)
      if (
        hasProfessionalToken &&
        (isProfessionalAppRoute ||
          professionalSteps === 4 ||
          professionalSteps === 1)
      ) {
        setAuthType("professional");
      } else if (hasClientToken && clientSteps === 2) {
        setAuthType("client");
      } else {
        setAuthType("none");
      }
    };

    checkAuth();
    window.addEventListener("storage", checkAuth);
    window.addEventListener("authStateChanged", checkAuth);
    return () => {
      window.removeEventListener("storage", checkAuth);
      window.removeEventListener("authStateChanged", checkAuth);
    };
  }, [location.pathname]);

  // React to logout immediately
  useEffect(() => {
    const handleLogoutEvent = () => {
      setAuthType("none");
      navigate("/");
    };

    window.addEventListener("logout", handleLogoutEvent);
    return () => window.removeEventListener("logout", handleLogoutEvent);
  }, [navigate]);

  // Handle custom footer toggle event
  useEffect(() => {
    const handleToggleFooter = (e) => {
      setShowFooter(e.detail); // e.detail = true or false
    };

    window.addEventListener("toggleFooter", handleToggleFooter);
    return () => window.removeEventListener("toggleFooter", handleToggleFooter);
  }, []);

  return (
    <>
      {globalLoading && <Loader />}
      <div
        className={globalLoading ? "global-blur" : undefined}
        style={{
          minHeight: '100vh',
          position: 'relative',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        {/* <div className="topbar"> ... </div> */}
        <ToastContainer position="top-right" autoClose={3000} />

        {/* HEADER */}
        {authType === "professional" && <ProfessionalHeader />}
        {authType === "client" && <ClientHeader />}
        {authType === "none" && <CommonHeader />}

        {/* MAIN CONTENT */}
        <div
          className={[
            "app-main-content",
            authType === "professional" ? "app-main-content--professional" : "",
            authType === "client" ? "app-main-content--client" : "",
          ]
            .filter(Boolean)
            .join(" ")}
        >
          <AnimatedOutlet />
        </div>

        {/* FOOTER */}
        {showFooter && !globalLoading && (
          <>
            {authType === "professional" && <ProfessionalFooter />}
            {authType === "client" && <ClientFooter />}
            {authType === "none" && <CommonFooter />}
          </>
        )}
      </div>
     
    </>
  );
};

export default LayoutHandler;
